import { SxProps } from '@mui/material';

export const hideUnavailablePageArrows: SxProps = {
  '& .MuiTablePagination-actions .MuiIconButton-root.Mui-disabled': {
    visibility: 'hidden'
  }
};
